export default __webpack_public_path__ + "static/logo-mec-e6d18c1fc7f7b503a80ce470190f55de.jpg";